import React from 'react';
import { getTrackColorByStateAndDifficulty } from "../../helpers/map";
import { tracksWidth, arrowWidth } from "../../config/defaults";
import { TRACK_DIFFICULTY_RED } from "../../config/constants";

const Connector16CBlack16ARed = ({ state, workState }) => (
   <g id="Track-16A-red-connector" transform="translate(2318.000000, 390.000000)">
      <g id="line"
         transform="translate(0.000000, 0.738544)"
         stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
         strokeLinecap="round"
      >

         <line x1="0" y1="41.2264748" x2="32.6293933" y2="32.6244013"
               strokeWidth={tracksWidth}/>
      </g>
   </g>
);

export default Connector16CBlack16ARed;
